module.exports = __webpack_public_path__ + "static/img/qcsh3.c3ae1e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/qcsh3.jpg
// module id = blFG
// module chunks = 0